module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAAAoElEQVRYhe3YwQmEMBAF0B/ZArYUOxCrmbOVrNdUs2sHlrIdxKMjg34XQcLy38lkJHxIGIOplIKaNFWlUaATFIhRIOZB6pSZ+UbW55w/V9bTljEKxCgQU12gw/uQmbUAnqGw9XajAcAc3nBYn2KNcQTQhdl9r93KKoUZR2eIOTxDZ+hbdjcFYhSI+b87NYDJPX9D9Uf62cAoEKNATF2BACwnCR9PHVDW7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_add.png
// module id = KLdF
// module chunks = 4